// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.download-link {
  margin-top: 10px;
  cursor: pointer;
  color: rgb(0, 126, 167);
}

.download-link:hover {
  text-decoration: underline;
  -webkit-text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/components/noAuthFileShare/components/style.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,kCAAkC;AACpC","sourcesContent":[".download-link {\n  margin-top: 10px;\n  cursor: pointer;\n  color: rgb(0, 126, 167);\n}\n\n.download-link:hover {\n  text-decoration: underline;\n  -webkit-text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
